import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";

//Importing Modal


class Section extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
    };
  }

  

  render() {
    return (
      <React.Fragment>
        <section className="section bg-home home-half" id="home" data-image-src="images/bg-home.jpg"> 
          <div className="bg-overlay"></div>
          <Container>
            <Row>
              <Col
                lg={{ size: 8, offset: 2 }}
                className="text-white text-center"
              >
                <h4 className="home-small-title">Awesome Design</h4>
                <h1 className="home-title">
                  We love make things amazing and simple
                </h1>
                <p className="pt-3 home-desc mx-auto">
                  Maecenas class semper class semper sollicitudin lectus lorem
                  iaculis imperdiet aliquam vehicula tempor auctor curabitur
                  pede aenean ornare.
                </p>
                
              </Col>
              
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default Section;
